import { formatCurrency } from '@/common/utils/formatters'
import { ShieldCheckIcon } from 'lucide-react'
import { ReactNode } from 'react'
import ProposalAwareResumeItem from '../ProposalAwareResumeItem'

interface ProposalAwareValuesRowProps {
  originalUnitPrice: number
  displayNewUnitPrice: number | null
  unitPricePercentage: string | null
  originalTotalValue: number
  displayNewTotalValue: number | null
  totalValuePercentage: string | null
  originalWarranty: number
  displayNewWarranty: number | null
  quantityDisplay: ReactNode
}

const ProposalAwareValuesRow = ({
  originalUnitPrice,
  displayNewUnitPrice,
  unitPricePercentage,
  originalTotalValue,
  displayNewTotalValue,
  totalValuePercentage,
  originalWarranty,
  displayNewWarranty,
  quantityDisplay,
}: ProposalAwareValuesRowProps) => {
  return (
    <div className="flex items-center flex-wrap flex-1 gap-2 justify-between">
      <ProposalAwareResumeItem
        label="Garantia em dias"
        Icon={ShieldCheckIcon}
        originalValue={originalWarranty}
        newValue={displayNewWarranty}
        format={(value) => `${value} dias`}
        higherIsBetter
      />

      <div className="flex items-center gap-1">
        <ProposalAwareResumeItem
          label="Valor unitário"
          originalValue={originalUnitPrice}
          newValue={displayNewUnitPrice}
          differencePercentage={unitPricePercentage}
          format={formatCurrency}
        />

        <p className="text-sm">x</p>

        {quantityDisplay}

        <p className="text-sm">=</p>

        <ProposalAwareResumeItem
          label="Valor total"
          originalValue={originalTotalValue}
          newValue={displayNewTotalValue}
          differencePercentage={totalValuePercentage}
          format={formatCurrency}
          className="bg-success-op text-success-tertiary"
        />
      </div>
    </div>
  )
}

export default ProposalAwareValuesRow
